export const config = {
    baseURL: 'https://canteen.icimod.org/api'
    // baseURL: 'http://localhost:3000'
};
